<template>
  <BaseTableWrapper>
    <template #top-buttons>
      <div class="float-right mb-1">
        <router-link tag="button" :to="{ name: 'EXABCustomFieldsCreate' }" class="btn btn-sm btn-primary">{{ $t('buttons.create') }}</router-link>
      </div>
    </template>
    <template #filtering>
      <div class="text-right">
        <b-button class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.userdata_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
      </div>
      <div>
        <b-collapse id="userdata_search_collapse" class="mt-2">
          <CustomFieldFiltering :customFieldTypeOptions="customFieldTypeOptions" @getPage="getPage($event)"></CustomFieldFiltering>
        </b-collapse>
      </div>
    </template>
    <template #body>
      <div v-if="isLoading">
        <Loader></Loader>
      </div>
      <div v-else-if="!isLoading && items.length < 1">
        {{ $t('views.customfields.list.noCustomFields') }}
      </div>
      <div v-else>
        <table class="table table-sm table-responsive-md table-striped table-hover">
          <thead>
          <tr>
            <th>{{ $t('global.title') }}</th>
            <th>{{ $t('views.externalform.form.fieldType') }}</th>
            <th style="width: 5%"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item['@id']">
            <td>{{ item.label }}</td>
            <td>{{ getFieldTypeText(item.customFieldType) }}</td>
            <td>
              <b-dropdown variant="link" size="sm" right text="Right align">
                <template #button-content>
                  <i class="fa fa-bars fa-lg"></i>
                </template>
                <b-dropdown-item @click="editItem(item)"><i class="fa fa-edit mr-2"></i>{{$t('buttons.edit')}}</b-dropdown-item>
                <b-dropdown-item v-if="item.state === 1 " @click="archiveItem(item)"><i class="fa fa-edit mr-2"></i>{{$t('buttons.archive')}}</b-dropdown-item>
                <b-dropdown-item v-if="item.state === 0 " @click="unArchiveItem(item)"><i class="fa fa-edit mr-2"></i>{{$t('buttons.unArchive')}}</b-dropdown-item>
              </b-dropdown>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="view">
        <Pagination :view="view" @getPage="getPage($event)"></Pagination>
      </div>
    </template>
  </BaseTableWrapper>
</template>

<script>
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import Loader from '@/components/Dashboard/Layout/Loader'
import { mapActions, mapGetters } from 'vuex'
import addParamsToQuery from '@/utils/addParamsToQuery'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles'
import CustomFieldFiltering from '@/components/Dashboard/Views/AgreementsBundle/customfields/components/CustomFieldFiltering'
import ApiService from '@/utils/ApiService'

export default {
  name: 'List',
  components: {
    CustomFieldFiltering,
    BaseTableWrapper,
    Pagination,
    Loader
  },
  data () {
    return {
      searchParams: {
        state: 1
      },
      customFieldTypeOptions: [
        {
          text: this.$t('global.all'),
          value: undefined
        },
        {
          text: this.$t('views.externalform.form.customFieldTypeOptions.input'),
          value: 1
        },
        {
          text: this.$t('views.externalform.form.customFieldTypeOptions.label'),
          value: 2
        },
        {
          text: this.$t('views.externalform.form.customFieldTypeOptions.date'),
          value: 3
        },
        {
          text: this.$t('views.externalform.form.customFieldTypeOptions.select'),
          value: 4
        }
      ]
    }
  },
  beforeCreate () {
    checkPagePermission('exabagreements', 'EXABCustomFieldsList')
  },
  props: ['item'],
  computed: {
    ...mapGetters({
      error: 'customfields/list/error',
      items: 'customfields/list/items',
      isLoading: 'customfields/list/isLoading',
      view: 'customfields/list/view'
    }),
    ableToCreateCustomField () {
      return checkPermission('exabagreements', 'EXABCustomFieldsCreate')
    }
  },
  created () {
    this.getPage(addParamsToQuery('e_x_a_b_custom_fields', this.searchParams))
  },
  methods: {
    ...mapActions({
      getPage: 'customfields/list/getItems'
    }),
    archiveItem (item) {
      this.$Swal({
        title: this.$t('notifications.archiveTitle') + ' ' + this.$t('notifications.archiveDescription'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          const response = new ApiService(item['@id']).put({ state: 0 })
          response.then(res => {
            this.searchParams.state = 1
            this.getPage(addParamsToQuery('e_x_a_b_custom_fields', this.searchParams))
          })
        }
      })
    },
    unArchiveItem (item) {
      const response = new ApiService(item['@id']).put({ state: 1 })
      response.then(res => {
        this.searchParams.state = 0
        this.getPage(addParamsToQuery('e_x_a_b_custom_fields', this.searchParams))
      })
    },
    editItem (item) {
      this.$router.push({ name: 'EXABCustomFieldsUpdate', params: { id: item['@id'] } })
    },
    getFieldTypeText (val) {
      return this.customFieldTypeOptions.find(option => parseInt(val) === option.value).text
    }
  }
}
</script>

<style scoped>

</style>
